<div>
  <div class="mb-4 flex w-full flex-col gap-1">
    @for (file of filesCustom; track file) {
      <qaroni-upload-files-item
        [file]="file"
        (uploadedFile)="onUploadedFile()"
        (deleteFile)="onDeleteFile($event)" />
    }
  </div>

  <div
    qaroniFilesDragAndDrop
    (files)="getFiles($event)"
    class="qaroni-container-upload-drop-files qaroni-content-file-upload mb-2 w-full text-center">
    <label class="qaroni-link-on-surface flex flex-col items-center">
      <input class="hidden" type="file" (change)="onFileSelected($event)" />
      <mat-icon class="qaroni-mat-icon-32"> add_circle </mat-icon>
      <span i18n>Subir archivos</span>
    </label>
  </div>

  <div
    [ngClass]="{
      'grid grid-cols-12': isRow(),
      'flex flex-col space-y-2': !isRow(),
    }"
    class="qaroni-text-time text-black-50">
    <div
      [ngClass]="{
        'text-black-50': filesCustom?.length === 0,
        'text-danger': iconErrorSize === 'unpublished',
        'text-success': iconErrorSize === 'check_circle',
        isRow: 'col-span-12 items-center md:col-span-3 lg:col-span-4',
      }">
      <mat-icon class="qaroni-mat-icon-14"> {{ iconErrorSize }} </mat-icon>
      <span class="ms-1" i18n>Archivo menor a 3 MB</span>
    </div>
    <div
      [ngClass]="{
        'text-black-50': filesCustom?.length === 0,
        'text-danger': iconErrorType === 'unpublished',
        'text-success': iconErrorType === 'check_circle',
        isRow: 'col-span-12 flex items-center md:col-span-9 lg:col-span-8',
      }">
      <div class="flex items-center">
        <mat-icon class="qaroni-mat-icon-14"> {{ iconErrorType }} </mat-icon>
        <span class="ms-1" i18n>Tipo de formatos permitidos</span>
      </div>
      <div class="mx-2 flex items-center">
        <span class="ms-1">
          jpg, png, jpeg, svg, webp , pdf, xls, xlsx, docx, doc, pptx, ppt, odt
        </span>
      </div>
    </div>
  </div>
</div>
